import classNames from 'classnames/bind'
const Button = props => (
  <button
    id={props.id}
    type={props.type}
    style={props.style}
    className={classNames({
      'ma-button': true,
      'button': true,
      'is-outlined': props.outlined,
      'is-loading': props.loading,
      [`is-${props.btType}`]: props.btType,
      [`${props.className}`]: props.className
    })}
    onClick={props.onClick || props.handleClick}
    disabled={props.disabled}
  >
    {props.children}
  </button>
)

Button.defaultProps = {
  btType: 'default'
}

export default Button



// WEBPACK FOOTER //
// ./components/uiLib/Button/index.js